export default "__VITE_ASSET__DYiIYu$A__"